import { SITE, FOOTER_COPY } from '@/content/yawasCopy';
import { DEFAULT_OPENING_HOURS } from '@/content/openingHours';

export const restaurantInfo = {
  name: SITE.name,
  tagline: 'Geschmackszyklus',
  description: FOOTER_COPY.description,
  logo: '/branding/yawas-kebab-logo-on-light.png',
  logoInverse: '/branding/yawas-kebab-logo-on-dark.png',
  phone: SITE.phoneDisplay,
  email: SITE.email,
  address: SITE.addressOneLine,
  openingHours: DEFAULT_OPENING_HOURS,
  deliveryFee: 3.90,
  minimumOrder: 20.00,
  estimatedDelivery: '30–45 Min.',
  estimatedPickup: '15–20 Min.',
  taxRate: 0.077,
};

export const testimonials = [
  {
    id: 1,
    name: 'Markus Huber',
    role: 'Stammkunde aus St. Gallen',
    text: 'Die Smash Burger bei Yawas Kebab sind hervorragend – frisch, saftig und mit echter Qualität.',
    avatar: 'https://readdy.ai/api/search-image?query=friendly%20Swiss%20man%20smiling%20portrait%2C%20casual%20style%2C%20warm%20smile%2C%20neutral%20background%2C%20professional%20headshot%20photography&width=200&height=200&seq=ut1&orientation=squarish',
    rating: 5,
  },
  {
    id: 2,
    name: 'Sandra Meier',
    role: 'Kundin aus St. Gallen',
    text: 'Freundlicher Service und ein Döner, der begeistert. Unser Lieblingsimbiss in St. Gallen.',
    avatar: 'https://readdy.ai/api/search-image?query=Swiss%20woman%20smiling%20portrait%2C%20casual%20elegant%20style%2C%20warm%20lighting%2C%20neutral%20background%2C%20professional%20headshot%20photography&width=200&height=200&seq=ut2&orientation=squarish',
    rating: 5,
  },
  {
    id: 3,
    name: 'Thomas Keller',
    role: 'Stammkunde',
    text: 'Hausgemachte Patties und herzliche Gastfreundschaft – seit 2021 unser fester Treffpunkt.',
    avatar: 'https://readdy.ai/api/search-image?query=middle%20aged%20Swiss%20man%20smiling%20portrait%2C%20casual%20look%2C%20warm%20smile%2C%20neutral%20background%2C%20professional%20headshot%20photography&width=200&height=200&seq=ut3&orientation=squarish',
    rating: 5,
  },
];
